import Collapsed from './collapsed.js';
for ( const element of document.querySelectorAll( '.iportal-collapsed' ) ) {
		new Collapsed( element );
}

import ContentModulePopup from './popup.js';
for ( const element of document.querySelectorAll( '.iportal-popup' ) ) {
	new ContentModulePopup( element );
}

import PrintableElements from './printable-elements.js';
new PrintableElements();

import ImageZoom from './image-zoom.js';
new ImageZoom();

import LanguageSwitcher from './language-switcher.js';
for ( const element of document.querySelectorAll( '.language-switcher' ) ) {
	new LanguageSwitcher( element );
}

import PageRating from './page-rating.js';
for ( const element of document.querySelectorAll( '.content-page-rating--rating-enabled' ) ) {
	new PageRating( element );
}

import SubscriptionsModal from './subscriptions-modal.js';
new SubscriptionsModal();

import CodeDoubleclick from './code-doubleclick.js';
for ( const element of document.querySelectorAll( 'code' ) ) {
	new CodeDoubleclick( element );
}

if ( document.querySelectorAll( '.iportal-itable' ).length > 0 ) {
	import('./itable.js').then( ( ITable ) => ITable.loadITable() );
}

const formMakerSubmissions = document.querySelectorAll(
	'.form-maker-submissions'
);
if ( formMakerSubmissions.length > 0 ) {
	import('./form-maker-submissions.jsx').then(
		( module ) => {
			for ( const element of formMakerSubmissions ) {
				wp.element.render(
						<module.default statsBegin={element.dataset.statsBegin}/>,
					element
				);
			}
		}
	);
}

import Time from './time.js';
for ( const element of document.querySelectorAll( 'time' ) ) {
	new Time( element );
}
